import styled from 'styled-components'

import Button from '@material-ui/core/Button'

export const StyledButton = styled(Button)`
  width: ${ ({ fullWidth }) => fullWidth ? '100%' : 'auto' };
  font-size: 13px;
  font-weight: bold;
  padding: 8px 20px;
`
